import React from "react";
import { Routes, Route } from "react-router-dom";


import Header from "./components/main/Header";
import Footer from "./components/main/Footer";
// Pages

import Home from "./components/pages/Home";
import Testimonials from "./components/pages/Testimonials";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import TermsOfService from "./components/pages/TermsOfService";
import Faqs from "./components/pages/Faqs";
import ContactUs from "./components/pages/ContactUs";
import Blog from "./components/pages/Blog";
import Services from "./components/pages/Services";
import AboutUs from "./components/pages/AboutUs";
import Properties from "./components/pages/Properties";
import BlogDetails from "./components/pages/BlogDetails";
import PropertiesPlaces from "./components/pages/PropertiesPlaces";
import AllPropertiesPlaces from "./components/pages/AllPropertiesPlaces";
import LandDetailes from "./components/pages/LandDetailes";

// Start Hooks
import UseScrollAnimation from "./hooks/UseScrollAnimation";
import ScrollToTop from "./components/ScrollToTop";
import Top from './components/Top';

function App() {
    return (
        <>
            <Header />
            <Top />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/testimonials" element={<Testimonials />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/faqs" element={<Faqs />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/properties" element={<Properties />} />
                <Route path="/blogDetails/:id" element={<BlogDetails />} />
                <Route path="/propertiesPlaces/:id" element={<PropertiesPlaces />} />
                <Route path="/allPropertiesPlaces" element={<AllPropertiesPlaces />} />
                <Route path="/landDetailes/:id" element={<LandDetailes />} />
            </Routes>
            <Footer />
            <ScrollToTop />
            <UseScrollAnimation />
        </>
    );
}

export default App;
